import SettingsAccessibilityIcon from "@mui/icons-material/SettingsAccessibility";
import ListPreferences from "./List";
import { PREFERENCES, AdministrationServicePath } from "utils/constants";
import EditPreferences from "./Edit";
import CreatePreferences from "./Create";
import ShowPreferences from "./Show";
import permissions from "app/permissions";

//permissions
export const resources = {
  isMenu: true,
  icon: <SettingsAccessibilityIcon />,
  name: AdministrationServicePath + PREFERENCES,
  title: "Преференции",
  list: <ListPreferences />,
  create: <CreatePreferences />,
  createPermission: permissions.canCreatePreferences,
  edit: <EditPreferences />,
  editPermission: permissions.canManagePreferences,
  show: <ShowPreferences />,
  showPermission: permissions.canPreviewPreferences,
  permission: permissions.canPreviewPreferences,
};
